var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-app-bar',{attrs:{"app":"","clipped-left":"","color":"white"}},[_c('v-toolbar-title',[_c('img',{attrs:{"src":_vm.career.company_logo,"height":"45","alt":"Gugla Empregos"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }